import { createGlobalStyle } from "styled-components"
import tw from "twin.macro"
import TransitionStyles from "./TransitionStyles"

// @media (max-width: 300px) for galaxy fold

const GlobalStyle = createGlobalStyle`
  :root{
    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --neutralLight: #f7f7f7;
    --barleyWhite: #F9F1BA;
    --amaranth: #DC2249;
    --bitterSweet: #FF6E6E;
    --deepSky: #00ADFF;
    --neonPurple: #6937FF;
    --violet: #221E41;
    --cosmic: #7A4865;
    --springWood: #E5DCD3;
    --suvaGrey: #8A8785;
    --neutralDark: #161718;
    --burntSiena: #EE7C51;

    --light-deepSky: rgba(0,173,255,0.15);

    --tab-height: 42px;
    --tab-width: 120px;

    --font-mono: Consolas;
    --shadow: rgba(0,0,0.5);
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
    font-size: 14px;

    @media(min-width: 768px){
      font-size: 16px;
    }

    @media(max-width: 300px){
      font-size: 12px;
    }
  }
  
  ::selection{
    background: rgba(0,0,0,0.25);
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--suvaGrey);
    border-radius: 4px;
  }

  body{
    ${tw`bg-neutralDark m-0 p-0 text-neutralLight font-poppins w-full min-h-full`}
    overflow-x: hidden !important;
  }

  #root{
    ${tw`min-h-screen h-screen grid px-4 xl:px-0`}
    grid-template-rows: 1fr auto;
    grid-template-columns: 100%;
    margin: 0 auto;
    max-width: 1180px;
  }

  a{
    ${tw`no-underline`}
  }

  button{
    ${tw`font-poppins`}
  }

  .scroll-bg {
    -webkit-animation-name: scrollSmall;
    animation-name: scrollSmall;
    -webkit-animation-duration: 15s;
    animation-duration: 15s;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite

    @media (min-width: 1024px) {
      -webkit-animation-name:scrollLarge;
      animation-name: scrollLarge;
      -webkit-animation-duration: 35s;
      animation-duration: 35s;
      -webkit-animation-timing-function: linear;
      animation-timing-function: linear;
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite
    }
  }

  @-webkit-keyframes scrollSmall {
    0% {
      transform: rotate(-13deg) translateY(0)
    }

    to {
      transform: rotate(-13deg) translateY(-639px)
    }
  }

  @keyframes scrollSmall {
    0% {
      transform: rotate(-13deg) translateY(0)
    }

    to {
      transform: rotate(-13deg) translateY(-639px)
    }
  }

  @-webkit-keyframes scrollLarge {
    0% {
      transform: rotate(-13deg) translateY(0)
    }

    to {
      transform: rotate(-13deg) translateY(-1278px)
    }
  }

  @keyframes scrollLarge {
    0% {
      transform: rotate(-13deg) translateY(0)
    }

    to {
      transform: rotate(-13deg) translateY(-1278px)
    }
  }


  ${TransitionStyles}
`

export default GlobalStyle
